import { useEffect, useState } from 'react'
import { getSupportedLocales, subscribeSupportedLocales } from '@utils'

export function useSupportedLocales(): string[] {
  const [locales, setLocales] = useState(getSupportedLocales)

  useEffect(() => subscribeSupportedLocales(() => setLocales(getSupportedLocales())), [])

  return locales
}
